import script from "./RoutePoints.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutePoints.vue?vue&type=script&setup=true&lang=js"

import "./RoutePoints.vue?vue&type=style&index=0&id=09e55156&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e55156"]])

export default __exports__